import { styled } from '@mui/material/styles';
import { globalClasses } from 'core/common/constants/global-classes';
import { LinearProgress, Typography } from 'core/common/ui/ui-kit';
import { applicationSidePaddingPx } from 'core/theme/constants';

export const ProgressContainerStyled = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 24px;
  margin-top: 8px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 ${applicationSidePaddingPx}px;
`;

export const StepsContainerStyled = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & > ${globalClasses.MuiLinearProgressBarRoot}:not(:last-child) {
    margin-inline-end: 8px;
  }
`;

export const LinearProgressStyled = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== 'isAnimated',
})<{ isAnimated: boolean }>`
  ${globalClasses.MuiLinearProgressBar} {
    transition: ${({ isAnimated }) => (isAnimated ? 'transform 0.5s linear' : 'none')};
  }
`;

export const TitleContanerStyled = styled('div')`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  padding-right: 35px;
  padding-left: 35px;
`;

export const CurrentStepStyled = styled(Typography)`
  position: absolute;
  top: 50%;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 2px 4px;
  border-radius: 50px;
  font-weight: 500;
  background-color: ${({ theme }) => theme.palette.contentBlockBackground.secondary};
  transform: translateY(-50%);
`;
